import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import InfoTag from '../InfoTag';
import ScrollableRow from '../ScrollableRow';
const RallyThemesRow = ({ themes }) => {
    return (_jsx("div", { className: "rally-themes-row", children: _jsx(ScrollableRow, { children: themes.map((theme) => (_jsx(InfoTag, { backgroundColor: '#95C11F33', color: '#95C11F', textContent: theme.title }, String(theme.uid)))) }) }));
};
export default RallyThemesRow;
